import { render, staticRenderFns } from "./InfoPage.vue?vue&type=template&id=484a574a&"
import script from "./InfoPage.vue?vue&type=script&lang=ts&"
export * from "./InfoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports